// extracted by mini-css-extract-plugin
export default {"wrapper":"a2zCCL","placeholderWrapper":"b2zCCL","placeholderHidden":"c2zCCL"};